import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { MOIS_FR } from "@/lib/api";

const TOUS = "all";

// value : { annee: "2026" | "all", mois: "07" | "all" }
export const filtreParams = (v) => {
  if (!v || v.annee === TOUS) return {};
  return v.mois === TOUS ? { annee: v.annee } : { mois: `${v.annee}-${v.mois}` };
};

export const MoisAnneeFilter = ({ value, onChange, annees, toutes = false, testId = "mois-annee-filter" }) => (
  <div className="flex gap-2" data-testid={testId}>
    <Select value={value.annee} onValueChange={(annee) => onChange({ annee, mois: annee === TOUS ? TOUS : value.mois })}>
      <SelectTrigger className="h-11 w-36 bg-white" data-testid={`${testId}-annee`}><SelectValue /></SelectTrigger>
      <SelectContent>
        {toutes && <SelectItem value={TOUS}>Toutes les années</SelectItem>}
        {annees.map((a) => <SelectItem key={a} value={a} data-testid={`${testId}-annee-${a}`}>Année {a}</SelectItem>)}
      </SelectContent>
    </Select>
    <Select value={value.mois} onValueChange={(mois) => onChange({ ...value, mois })} disabled={value.annee === TOUS}>
      <SelectTrigger className="h-11 w-40 bg-white" data-testid={`${testId}-mois`}><SelectValue /></SelectTrigger>
      <SelectContent>
        <SelectItem value={TOUS}>Toute l'année</SelectItem>
        {MOIS_FR.map((m, i) => {
          const v = String(i + 1).padStart(2, "0");
          return <SelectItem key={v} value={v} data-testid={`${testId}-mois-${v}`}>{m}</SelectItem>;
        })}
      </SelectContent>
    </Select>
  </div>
);

export const anneesDepuis = (mois) => [...new Set(mois.map((m) => m.slice(0, 4)))].sort().reverse();
